export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14094.389e465d.jpg";